import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // Check if dialog is not already open before calling showModal
    if (!this.element.open) {
      this.element.showModal()
    }
  }

  remove() {
    this.element.close()
    this.element.remove()
  }

  submit(e) {
    e.preventDefault()

    const form = this.element.closest('form')
    if (form) {
      form.requestSubmit()
    }
    this.remove()
  }
}
